import { ADN_PLUS } from '../models/ADN_PLUS';
import { EntityField } from '../models/EntityField';
import { HttpService } from '../services/http.service';
import { ActionService } from '../services/action.service';
import { ServiceLocator } from "../ServiceLocator";
// import { NotificationsService } from './notifications-module';
import { Action, ActionType } from '../models/Action';
import { UtilService } from '../services/util.service';
import { MessageService } from '../services/message.service';
import { SpinnerService } from '../services/spinner.service';
import { OperationParam } from '../models/OperationParam';
import { Observable } from 'rxjs';
import { PlusNotificationService } from '../services/plus-notification.service';
import { ConfirmationService } from '../services/confirmation.service';
import { ChangeDetectorRef, Component, ComponentFactoryResolver } from '@angular/core';
import { AuthService, MenuService, PaintService, PlusAlertsService, StoreService } from '../services';
import { ViewContainerRef } from '@angular/core';
import { ModalButtonColor, ModalIconType, ModalType } from '../enums/modal';
import { ElementViewportPosition } from '../models';
import { PfComponents } from '../enums/pfComponents';


@Component({
  selector: 'ctrl-base',
  template: '',
  styles: ['']
})

export class CtrlBaseComponent {
  private id: string;
  private name: string;
  private ctType: string;
  private metaData: any;
  private styleClass: any;
  private mdStyleClass: any;
  private smStyleClass: any;
  private xsStyleClass: any;
  private customCss: string;
  protected childElements: CtrlBaseComponent[] = [];
  private controlActions: Action[] = [];
  private viewId: string;
  private hidden: boolean;
  private modelId: string;
  private showRedDot: boolean = false;

  //Roles
  private hideWhenKey: string;
  private hideWhenKeyValue: string;
  private keyValueSplitter: string = ",";
  private keySource: string;

  //Components
  protected httpService: HttpService;
  protected actionService: ActionService;
  protected listenersComponents: any[] = [];
  protected utilService: UtilService;
  protected messageService: MessageService;
  protected spinnerService: SpinnerService;
  protected plusNotService: PlusNotificationService;
  protected confirmService: ConfirmationService;
  protected paintService: PaintService;
  protected isLoading: boolean;
  protected compiler: ComponentFactoryResolver
  protected plusAlertService: PlusAlertsService
  protected menuService: MenuService;
  protected spinnerConfig = {
  }
  protected authService: AuthService;
  protected storeService: StoreService;

  listenedProperty: any;
  listenedComponentId: any;
  listernerTimes = 0;
  listernerExTimes = 0;
  //componentRef: ComponentRef<any>;

  constructor() {
    this.httpService = ServiceLocator.injector.get(HttpService);
    this.actionService = ServiceLocator.injector.get(ActionService);
    this.utilService = ServiceLocator.injector.get(UtilService);
    this.messageService = ServiceLocator.injector.get(MessageService);
    this.spinnerService = ServiceLocator.injector.get(SpinnerService);
    this.plusNotService = ServiceLocator.injector.get(PlusNotificationService);
    this.confirmService = ServiceLocator.injector.get(ConfirmationService);
    this.paintService = ServiceLocator.injector.get(PaintService);
    this.compiler = ServiceLocator.injector.get(ComponentFactoryResolver);
    this.plusAlertService = ServiceLocator.injector.get(PlusAlertsService);
    this.authService = ServiceLocator.injector.get(AuthService);
    this.storeService = ServiceLocator.injector.get<StoreService>(StoreService);
    this.menuService = ServiceLocator.injector.get<MenuService>(MenuService);
  }

  ngOnInit() {
    this.setProperties(this);
    this.hideComponentsOnKey(this)
  }

  //PROPERTIES
  getId() { return this.id };
  getName() { return this.name };
  getCtType() { return this.ctType };
  getMetaData() { return this.metaData };
  getStyleClass() { return this.styleClass ? this.styleClass : '' }
  getChildElements(): CtrlBaseComponent[] { return this.childElements };
  getControlActions(): any {
    if (!this.controlActions)
      this.controlActions = [];

    return this.controlActions;
  }
  getViewId(): string {
    if (!this.viewId)
      this.viewId = localStorage['currentView'];
    return this.viewId;
  }
  getHidden(): boolean { return this.hidden }
  getModelId(): string { return this.modelId }
  getIsloading(): boolean { return this.isLoading }
  getMetadataPropertyValue(propName: string): any { return this.getMetaData().controlProperties[propName]; }
  getListenedProperty(): any { return this.listenedProperty }
  getListenedComponentId(): any { return this.listenedComponentId }
  getCustomCss(): string { return this.customCss }
  getMdStyleClass(): string { return this.mdStyleClass }
  getSmStyleClass(): string { return this.smStyleClass }
  getXsStyleClass(): string { return this.xsStyleClass }
  getHideWhenKey(): string {return this.hideWhenKey}
  getHideWhenKeyValue(): string {return this.hideWhenKeyValue}
  getKeyValueSplitter(): string {return this.keyValueSplitter}
  getKeySource(): string {return this.keySource}
  getShowRedDot(): boolean{return this.showRedDot}
  setId(id: string) {
    if (!id) return
    let vViewRegex = new RegExp('^.{2}\\_VI[0-9]{1,5}\\_');
    if (!vViewRegex.test(id) && this.getCtType() != 'CtView')
      id = this.getViewId() + "_" + id;

    this.id = id
  };
  setShowRedDot(showRedDot: boolean){this.showRedDot = showRedDot}
  setName(name: string) { this.name = name };
  setCtType(ctType: string) { this.ctType = ctType };
  setMetaData(metaData: any) { this.metaData = metaData };
  setStyleClass(styleClass: any) { this.styleClass = styleClass }
  setControlActions(controlActions: any): void { this.controlActions = controlActions }
  setViewId(viewId: string): void { this.viewId = viewId }
  setHidden(hidden: boolean): void { this.hidden = hidden }
  setModelId(modelId: string): void { this.modelId = modelId }
  setIsloading(isLoading): void { this.isLoading = isLoading }
  setMetadataPropertyValue(propName: string, newValue: any): void { this.getMetaData().controlProperties[propName] = newValue; }
  setCustomCss(customCss: string) { this.customCss = customCss }
  setMdStyleClass(mdStyleClass: string) { this.mdStyleClass = mdStyleClass }
  setSmStyleClass(smStyleClass: string) { this.smStyleClass = smStyleClass }
  setXsStyleClass(xsStyleClass: string) { this.xsStyleClass = xsStyleClass }
  setHideWhenKey(hideWhenKey: string) {this.hideWhenKey = hideWhenKey}
  setHideWhenKeyValue(hideWhenKeyValue: string) {this.hideWhenKeyValue = hideWhenKeyValue}
  setKeyValueSplitter(keyValueSplitter: string) { this.keyValueSplitter = keyValueSplitter}
  setKeySource(keySource: string ) {this.keySource = keySource}
  setListenedProperty(listenedProperty: any): void { this.listenedProperty = listenedProperty }
  setListenedComponentId(pListenedComponentId: any): void {

    if (!pListenedComponentId) return;
    let vViewRegex = new RegExp('^.{2}\\_VI[0-9]{1,5}\\_');
    if (!vViewRegex.test(pListenedComponentId))
      pListenedComponentId = this.getViewId() + "_" + pListenedComponentId;
    this.listenedComponentId = pListenedComponentId;
  }

  setProperties(component: CtrlBaseComponent) {
    component.setCtType(component.getMetaData().ctType);
    component.setId(component.getMetaData().controlProperties.id ? component.getMetaData().controlProperties.id : ("defalutId" + component.getMetaData().ctType + Date.now()));
    component.setControlActions(component.getMetaData().controlActions);
    let controlProperties = component.getMetaData().controlProperties;
    for (let att in controlProperties) {
      if (controlProperties.hasOwnProperty(att)) {
        if (att === "formControl" || att === "controlActions" || att === "metaData") { continue }
        let value = controlProperties[att];
        let method = 'set' + att.charAt(0).toUpperCase() + att.slice(1);
        try {

          // if (method === 'setId' && this.viewId)
          //   value = this.viewId + "_" + value;

          component[method](value);
        } catch (e) {
          //console.error("Error: Invalid method: ", method, ", this can be cause because the attribute ", att, " doesn't exit in the component " + component.ctType);
        }
      }
    }
  }

  public addChildren(children: CtrlBaseComponent[]): void {
    for (let child of children)
      this.childElements.push(child);
  }

  public paintChildren(metadata: any, target: ViewContainerRef): Array<CtrlBaseComponent> {
    let newChilds = this.paintService.paintChildren(metadata, this.compiler, target);
    this.addChildren(newChilds);
    return newChilds;
  }

  /**
   * Busca un componente por su ID
   * @param childId ID del componente a buscar
   * @param recursive Si busca solo en los hijos de este componente o en toda la jerarquia
   * @returns El componente encontrado o null si no existe
   */
  public getChildById<T extends CtrlBaseComponent>(childId: string, recursive: boolean = false): T {
    let child = null;
    let i = 0;

    if (this.childElements) {
      while (child == null && i < this.childElements.length) {
        if (this.childElements[i].getId() === childId)
          child = this.childElements[i];
        else if (recursive)
          child = this.childElements[i].getChildById(childId, recursive);
        i++;
      }
    }

    return child;
  }

  /**
   * Filtra componentes por tipo
   * @param type Clase del componente a buscar
   * @param recursive Si busca solo en los hijos de este componente o en toda la jerarquia
   * @param breakLevel Si es recursivo indica el limite de busqueda en la jerarquia 
   * @param loopLevel (uso interno) Indica el indice actual de la jerarquia
   * @returns Lista de componentes filtrados por tipo, si no hay retorna un array vacio
   */
  public getChildsByType<T extends CtrlBaseComponent>(type: any, recursive: boolean = false, breakLevel: number = -1, loopLevel: number = 0): T[] {
    let childs = [];

    if (this.childElements && (breakLevel === -1 || loopLevel < breakLevel)) {
      for (let child of this.childElements) {
        if (child instanceof type)
          childs.push(child);
        else if (recursive) {
          let deepSearchResults = child.getChildsByType(type, recursive, breakLevel, loopLevel + 1);
          deepSearchResults.forEach(x => childs.push(x));
        }
      }
    }

    return childs;
  }

  setDynamicProperties(component: CtrlBaseComponent, att: any, value: any) {
    let setMethod = 'set' + att.charAt(0).toUpperCase() + att.slice(1);
    component[setMethod](value);
    this.listenerAction(component, att, value);
  }

  listenerAction(component: CtrlBaseComponent, att: any, value: any) {
    if (component.listenersComponents) {
      for (let listenerComponent of component.listenersComponents) {
        if (listenerComponent.attToListen === att) {
          let componentToNotify = this.utilService.getComponentRef(listenerComponent.componentId);

          if (componentToNotify)
            componentToNotify.executeListener(value);
        }
      }
    }
  }

  getUpdatedMetaData(): any {
    let metaData: any = {};

    metaData.ctType = this.getCtType();
    metaData.id = this.getId();
    metaData.controlActions = this.getControlActions();
    metaData.controlProperties = {};
    metaData.models = [];

    if (this.childElements) {
      this.childElements.forEach((el) => {
        metaData.models.push(el.getUpdatedMetaData());
      });
    }
    for (let att in this) {
      if (this.hasOwnProperty(att)) {
        if (att === "formControl" || att === "controlActions" || att === "metaData" || att === "formElements") { continue }
        let value = this[att];
        let method = 'get' + att.charAt(0).toUpperCase() + att.slice(1);
        try {
          metaData.controlProperties[att] = this[method](value);
        } catch (e) {
          //console.error("Error: Invalid method: ", method, ", this can be cause because the attribute ", att, " doesn't exit in the component " + component.ctType);
        }
      }
    }
    metaData.controlProperties.metaData = null;
    return metaData;
  }

  onInitComponent(isListenerSet = false) {
    if (!isListenerSet)
      this.setListeners();

    this.event2('onInit');

    if (this.childElements) {
      for (let child of this.childElements)
        if (child.id !== 'CT_' + child.viewId)
          child.onInitComponent(true);
    }
  }


  onInitActions(component: string, event: string): any {
    let componentRef;

    setTimeout(() => {
      componentRef = this.utilService.getComponentRef(component);
      let events = componentRef.getEvent(event);
      if (events)
        this.executeAction2(events);
    },0)



  }


  setListeners() {
    if (typeof this.setListener === "function") {
      // safe to use the function
      this.setListener();
      if (this.childElements) {
        for (let child of this.childElements)
          if (child.id !== 'CT_' + child.viewId)
            child.setListeners();
      }
    }
  }

  setListener(times?): void {
    let ac = this.getEvent('onListener');
    if (ac) {
      let componentRef = this.utilService.getComponentRef(this.getListenedComponentId());
      if (componentRef) {
        componentRef.addListener({ componentId: this.getId(), attToListen: this.listenedProperty })
      } else if (this.listernerTimes < 10) {
        // console.log(`Can't load listener ref, retrying on ${this.listernerTimes}s`);
        this.listernerTimes += 0.5;
        setTimeout(() => this.setListener(), (this.listernerTimes * 1000));
      }
    }
  }

  addListener(component) {
    this.listenersComponents.push(component);
  }

  executeListener(value) {
    if (value) {
      let ac = this.getEvent('onListener');
      this.executeAction2(ac);
    }
  }

  //API, THIS, OTHER, VIEW, CRUD, ACTION
  executeAction2(event: Action, response: any = null, callback = null, fallback = null) {

    if (!event)
      return;

    if ((event.params) && !(event.params instanceof OperationParam))
      event.params = OperationParam.BuildOperationParam(event.params);

    // Validate if the action has a pre action
    if (event.preAction) {

      let vMainAction = { ...event };

      event = event.preAction;

      event.postAction = vMainAction;

      return this.executeAction2(event, response, callback);
    }

    if (event.eventName != 'onListener' || (event.eventName == 'onListener' && this.utilService.currentViewId == this.viewId)) {
      let viewId;
      if (this.getCtType() == 'CtView') {
        viewId = this.id;
      } else {
        viewId = this.viewId;
      }
      localStorage.setItem("currentView", viewId);
      this.utilService.currentViewId = viewId;
    }

    // Executes the action
    try {
      if(!event.type) return;
      switch (event.type.toString()) {

        case '2':
        case 'OTHER':
          let otherActionArray = event.action.split(".");
          let otherRef = this.utilService.getComponentRef(otherActionArray[0]);

          if (otherRef)
            response = otherRef[otherActionArray[1]](event.actionParams, response);

          break;
        case '3':
        case 'VIEW':
          let componentRef = this.utilService.getComponentRef(this.viewId)//= $("#CT_" + (this.getCtType() === 'CtView' ? this.getId() : this.getViewId())).data("angularRef");

          if (componentRef) {

            if (event.action.startsWith("utl_")) {
              if (this.getViewId() && event.actionParams) {
                let viewId;
                if (this.getCtType() == 'CtView') {
                  viewId = this.id;
                } else {
                  viewId = this.viewId;
                }
                for (let vIndex = 0; vIndex < event.actionParams.length; vIndex++) {
                  if (event.actionParams[vIndex].indexOf(viewId) < 0)
                    event.actionParams[vIndex] = viewId + "_" + event.actionParams[vIndex];
                }
              }

              response = componentRef.localAction(event, response);
              // Permite ejecutar evetos de dentro de una referencia enviada.
            } else if ((event.action.split('.')).length > 1) {
              componentRef = this.utilService.getComponentRef(event.action.split('.')[0]);
              response = componentRef[event.action.split('.')[1]](event, response && response.Data ? response.Data : response);
            } else {
              response = componentRef[event.action.split('|')[0]](event, response && response.Data ? response.Data : response);
            }
          }

          break;

        case 'ENTITY':
          break;

        case '4':
        case 'CRUD':
          this.spinnerService.show();
          let entityActionArray = event.action.split(".");
          response = this.actionService.ExecuteCrudOperation(entityActionArray[0], entityActionArray[1], event, response, this, entityActionArray[2]);

          if (!response)
            response = false;

          break;

        case '5':
        case 'ACTION':
        case 'SERVICE':
          this.spinnerService.show();
          let serviceActionArray = event.action.split(".");
          response = this.actionService.ExecuteServiceOperation(serviceActionArray[0], serviceActionArray[1], event, response, this, serviceActionArray[2]);

          if (!response)
            response = false;

          break;

        default:
          response = this.actionService.ExecuteGenericOperation(event, response, this);
          
          if (!response)
            response = false;
      }
    } catch (ex) {
      if (fallback)
        fallback();
      throw ex;
    }

    if (response instanceof Observable) {
      return response.subscribe(x => {
        this.spinnerService.hide();
        let componentRef = this.utilService.getComponentRef(this.viewId);//= $("#CT_" + this.viewId).data("angularRef");

        if (typeof (x) === 'string')
          x = JSON.parse(x);

        if (callback)
          callback();
        if (x) {
          if (x.FilesData) {
            let dowloadEvent = { ...x }
            dowloadEvent.action = "utl_downloadFile";
            componentRef.localAction(dowloadEvent);
          }

          if (x.ResponseMessages && this.isMessageDisplayable(event))
            for (let m of x.ResponseMessages) {
              if (m.isStatic === 'S') {
                this.plusNotService.showTempStaticNotification(m);
              } else if (m.MessageCode != 'FPLUS.@DEF_MSG_RESULT') {

                this.plusAlertService.setCtDialogInfo(m.Title || 'Mensaje de información', ModalType.downloadError, ModalIconType.inspect, ModalButtonColor.primary, m.Message || m.MessageType.toLowerCase(),
                  true, 'De acuerdo', 'Cancelar');
              }
            }

          if (event.postAction) {
            const oldEvent = this.utilService.deepClone(event);
            delete oldEvent.preAction
            delete oldEvent.postAction;
            event = event.postAction;
            event.pastAction = oldEvent;
            delete event.preAction;
            return this.checkConfirmation(event, x, null, fallback)
            // return this.executeAction2(event, x, null, fallback);
          }
        }
        x;
      },
        (e) => {
          this.spinnerService.hide();
          if ((this.getCtType() === 'CtForm' && event.eventName === 'onListener') || this.getCtType() != 'CtForm')
            this.cleanComponentSelection();

          if (fallback)
            fallback(e);
          throw e;
        }
      );
    }
    else {
      if (callback)
        callback();

      if (fallback)
        fallback();

      if (response === false)
        return response;

      if (event.postAction) {
        const oldEvent = this.utilService.deepClone(event);
        delete oldEvent.preAction
        delete oldEvent.postAction;
        event = event.postAction;
        event.pastAction = oldEvent;
        delete event.preAction;
        return this.checkConfirmation(event, response, null, fallback)
        // return this.executeAction2(event, response, null, fallback);
      }
    }

    return response;
  }

  private isMessageDisplayable(event: Action) {
    try {
      const showMessage: boolean =
        event.utilParams.find(x => x.dataSource === 'constant' && x.name.split('=')[0] === 'showMessage')
          .name.split('=')[1] === 'true';
      if(!showMessage || showMessage === undefined || showMessage === null) return false;
      return showMessage;
    } catch (error) {
      return true;
    }
  }

  private hideComponentsOnKey(component: CtrlBaseComponent): void {
    const keySource = this.getKeySource();
    const hideWhenKey = this.getHideWhenKey();
    const keyValueSplitter = this.getKeyValueSplitter();
    let hideWhenKeyValue = this.getHideWhenKeyValue()?.toString();
    
    if (!keySource || !hideWhenKey || !keyValueSplitter || !hideWhenKeyValue) return;
    
    const keyValuesToHide = hideWhenKeyValue.split(keyValueSplitter);
    
    if (keySource === 'storeService') {
      this.handleStoreServiceSubscription(hideWhenKey, keyValuesToHide, component);
    } else {
      this.applyVisibilityBasedOnValues(keySource, hideWhenKey, keyValuesToHide, component);
    }
  }

  private handleStoreServiceSubscription(hideWhenKey: string, keyValuesToHide: string[], component: CtrlBaseComponent): void {
    this.storeService.getStateObservable(hideWhenKey).subscribe(storedValues => {
      let valuesArray: string[];
      if (storedValues === null || storedValues === undefined) {
      } else if (Array.isArray(storedValues)) {
        valuesArray = storedValues.map(value => value.toString());
      } else {
        valuesArray = [storedValues.toString()];
      }
      const shouldHide = valuesArray.some(value => keyValuesToHide.includes(value));
      component.setHidden(shouldHide);
    });
  }
  

  private applyVisibilityBasedOnValues(keySource: string, hideWhenKey: string, keyValuesToHide: string[], component: CtrlBaseComponent): void {
    const storedValues = (this as any)[keySource]?.[hideWhenKey];
    const valuesArray = Array.isArray(storedValues) 
      ? storedValues 
      : [storedValues];
    
    const shouldHide = valuesArray.some(value => keyValuesToHide.includes(value?.toString()));
    component.setHidden(shouldHide);
  }

  //ACTIONS

  protected event(eventName: string): void {

    if (!this.getControlActions()[eventName]) { return }
    //   this.executeAction(eventName);
  }

  public event2(eventName: string, callback?: any, fallback?: any): void {
    try {
      let event = this.getEvent(eventName);

      /*Listener on event layer, Should run once, even if not event signed to this action*/
      if (this.listenersComponents && this.listenersComponents.length > 0)
        this.listenerAction(this, eventName, true);

      if (event) {
        this.checkConfirmation(event, callback, fallback)
      }
    } catch (ex) {
      throw ex;
    }
  }

  checkConfirmation(event, response?: any, callback?: any, fallback?: any) {
    let confirmation = null;
    let type = null;
    let adnField = null;
    let inputLabel = null;

    if (event.utilParams) {
      confirmation = this.utilService.getEventUtilParam(event, 'cConfirmation', 'constant');
      type = this.utilService.getEventUtilParam(event, 'cMessageType', 'constant');
      adnField = this.utilService.getEventUtilParam(event, 'cAdnField', 'constant');
      inputLabel = this.utilService.getEventUtilParam(event, 'cInputLabel', 'constant');
    }
    if (confirmation == "true") {
      this.plusAlertService.setDefaultConfirmText(type);
      this.plusAlertService.showConfirmModal((confirmation) => {
        event.confirmValue = confirmation.inputFieldValue;
        event.confirmField = confirmation.adnFieldName;
        return this.executeAction2(event, response, () => {
          confirmation.bsModalRef.hide();
          this.plusAlertService.clearCallbacks();
        }, (x) => {
          if (x?.error_code == 'SESSION_EXPIRED') {
            confirmation.bsModalRef.hide();
            this.plusAlertService.clearCallbacks();
          } else {
            fallback ? fallback() : null;
          }

        })
      }, null, () => { this.executeAction2(event.pastAction, null, null, null) }, type, adnField, inputLabel);
    } else {
      return this.executeAction2(event, response, callback, fallback);
    }

    return false;
  }

  getEvent(eventName: string) {
    for (let event of this.getControlActions()) {
      if (event.eventName === eventName) {
        return this.utilService.deepClone(event);
      }
    }
    return undefined;
  }

  ajaxAction(viewId: string, viewAlias?: string, controllerName?: string, path?: string) {
    let url = HttpService.UIL + "/UIService/processAngularAction";// + path;
    //Armar el UiBehavior
    let uiContainer = {
      //viewRoot: { viewAlias: "Test", models: [sigmaView] },
      controller: controllerName ? { path: "/" + controllerName + "/" + path } : null,
      user: JSON.parse(localStorage.getItem('loggedUser')),
      sessionId: localStorage.getItem('SessionID'),
      viewAlias: viewAlias ? viewAlias : null
    }

    return this.httpService.post(url, uiContainer);
  }

  getAdnEntityValue(pAdn: ADN_PLUS, pFieldAlias: string) {

    var entityValue;

    pAdn.ArrayEntities.List.forEach(entityField => {
      if (entityField.Alias !== pFieldAlias)
        return true;

      entityValue = entityField.Value;
      return false;
    });

    return entityValue;

  }

  setAdnEntityValue(pAdn: ADN_PLUS, pFieldAlias: string, value: any): void {

    let userField = new EntityField();
    userField.Alias = pFieldAlias;
    userField.Value = value;
    pAdn.ArrayEntities.List.push(userField);

  }

  parsePlusDate(pPlusDate: any, pTimeAgo: any) {
    let plusDate: any = new Date(pPlusDate.replace(/^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)$/, '$4:$5:$6 $2/$3/$1'));

    if (pTimeAgo) {
      let actualTime: any = new Date();
      let msPerMinute = 60 * 1000;
      let msPerHour = msPerMinute * 60;
      let msPerDay = msPerHour * 24;
      let msPerMonth = msPerDay * 30;
      let msPerYear = msPerDay * 365;

      let elapsed = actualTime - plusDate;

      if (elapsed < msPerMinute) {
        return 'hace ' + Math.round(elapsed / 1000) + ' segundos';
      }

      else if (elapsed < msPerHour) {
        return 'hace ' + Math.round(elapsed / msPerMinute) + ' minutos';
      }

      else if (elapsed < msPerDay) {
        return 'hace ' + Math.round(elapsed / msPerHour) + ' horas';
      }

      else if (elapsed < msPerMonth) {
        return 'hace ' + Math.round(elapsed / msPerDay) + ' días';
      }

      else if (elapsed < msPerYear) {
        return 'hace ' + Math.round(elapsed / msPerMonth) + ' meses';
      }

      else {
        return 'hace ' + Math.round(elapsed / msPerYear) + ' años';
      }
    }

    return pPlusDate.toLocaleDateString() + " " + pPlusDate.toLocaleTimeString();
  }

  hasOnChangeAction(): boolean {

    for (let vControlAction of this.getControlActions()) {
      if (vControlAction.eventName !== "onChange")
        continue;

      return true;
    }

    return false;
  }

  cleanComponentSelection(): void {
    // console.log('Clean action caller');
  }

  showHideSpinner(value: boolean) {
    this.setIsloading(value);
  }

  getComponentRef() {

  }

  public getEffectiveClass(isMediumSize: boolean, isSmallSize: boolean, isExtraSmall: boolean): string {
    const classStyle = this.getStyleClass();

    if (classStyle) {
      return classStyle;
    }
    if (isMediumSize) {
      return this.getMdStyleClass();
    }
    if (isSmallSize) {
      return this.getSmStyleClass();
    }
    if (isExtraSmall) {
      return this.getXsStyleClass();
    }
    return ''; // default class or empty if none
  }

  /**
   * * Get the position of an element in the viewport (called from the utl_openGuidedTourDialog)
   * @param guidedTourTargetMenuOption 
   * @returns 
   */
  public getViewportPosition(guidedTourTargetMenuOption: string = ''): ElementViewportPosition {
    let elementId = guidedTourTargetMenuOption ? 
                    this.getMenuOptionId(guidedTourTargetMenuOption) : 
                    this.getId();
  
    const position : ElementViewportPosition = 
    this.getElementPosition(elementId, guidedTourTargetMenuOption ? true : false);         
    return position;
  }
  
  private getMenuOptionId(guidedTourTargetMenuOption: string): string {
    return this.menuService.menuComponent.getMenuItemId(guidedTourTargetMenuOption);
  }
  
  private getElementPosition(elementId: string, isMenuOption): ElementViewportPosition {
    if(!isMenuOption) elementId = this.getElementByComponent(elementId);
    const element = document.getElementById(elementId);
    if (!element) return new ElementViewportPosition(0, 0);
  
    const rect = element.getBoundingClientRect();

    let elementViewportPosition : ElementViewportPosition
      = new ElementViewportPosition(rect.right, rect.top);

    elementViewportPosition = this.calculateVarianceByElement(elementViewportPosition,
       isMenuOption);

    return elementViewportPosition;
  }

  private getElementByComponent(elementId : string): string {
    switch(this.getCtType()) {
      case PfComponents.CtHeader:
        return elementId + '_title';
      case PfComponents.CtButton:
        return elementId + '_button_text';
      default:
        return elementId;
    }
  }

  private calculateVarianceByElement(elementViewportPosition: ElementViewportPosition, 
      isMenuOption: any): ElementViewportPosition {
    if(isMenuOption) {
      elementViewportPosition.xAxis += 20;
      elementViewportPosition.yAxis -= 7;
      return elementViewportPosition;
    }

    switch(this.getCtType()) {
      case PfComponents.CtHeader:
        elementViewportPosition.xAxis += 20;
        elementViewportPosition.yAxis -= 18;
        return elementViewportPosition;
      case PfComponents.CtButton:
        elementViewportPosition.xAxis -= 715;
        elementViewportPosition.yAxis -= 10;
        return elementViewportPosition;
      default:
        return elementViewportPosition;
    }
  }
  
}
